import type { ReportGroup } from '../types';
import { overview } from './overview';

export const orderEditing = {
  key: 'orderEditing',
  label: 'Order Editing',
  isEnabled: ({ isOrderEditingEnabled }) => isOrderEditingEnabled,
  filters: {},
  reports: [overview],
} as const satisfies ReportGroup;
